import React, { useEffect, useState } from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
var ReactViewController = /** @class */ (function () {
    function ReactViewController(defaultInitialState, defaultRenderer) {
        var _this = this;
        this.defaultRenderer = defaultRenderer;
        this.state = defaultInitialState;
        this.setState = function (state) {
            _this.state = state;
        };
        this.render = this.render.bind(this);
        this.createElement = this.createElement.bind(this);
        this.replace = this.replace.bind(this);
        this.getState = this.getState.bind(this);
    }
    ReactViewController.prototype.getState = function () {
        return this.state;
    };
    ReactViewController.prototype.render = function () {
        var _this = this;
        if (this.element) {
            return this.element;
        }
        var ViewController = function () {
            var setState = useState(_this.state)[1];
            _this.setState = function (state) {
                // eslint-disable-next-line react/no-direct-mutation-state
                _this.state = state;
                setState(state);
            };
            useEffect(function () {
                return function () {
                    _this.setState = function (state) {
                        // eslint-disable-next-line react/no-direct-mutation-state
                        _this.state = state;
                    };
                    _this.getState = function () { return _this.state; };
                };
            }, []);
            return React.createElement(ErrorBoundary, null, _this.createElement(_this.state));
        };
        ViewController['displayName'] = this.constructor.name || 'ViewController';
        this.element = React.createElement(ViewController, null, null);
        return this.element;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ReactViewController.prototype.createElement = function (state) {
        var _a, _b;
        return (_b = (_a = this.defaultRenderer) === null || _a === void 0 ? void 0 : _a.call(this, state)) !== null && _b !== void 0 ? _b : null;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ReactViewController.prototype.replace = function (viewController) {
        // no-op
    };
    return ReactViewController;
}());
export { ReactViewController };
//# sourceMappingURL=ReactViewController.js.map